import { createFetcher } from '../../Common';

import { getBaseUrl, POSITION_DETAILS_END_POINT } from '../../constants';

export class Career {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Career(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = POSITION_DETAILS_END_POINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  /**
   * Fetch a single career by slug
   * @param {string} slug - The slug identifier for the career
   * @returns {Promise<Object>} Career data
   */
  async getCareerBySlug(slug, orgID) {
    const query = orgID != null ? `?orgID=${orgID}` : '';
    const url = `${this.base_url + this.endpoint}/${slug}${query}`;
    // eslint-disable-next-line
    try {
      // pass skipAuth down to fetcher
      const response = await this.fetcher.getPublicData(url);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
}

export const createCareer = () => Career.getInstance();
